import { render, staticRenderFns } from "./MyLogin.vue?vue&type=template&id=58f70de3&"
import script from "./MyLogin.vue?vue&type=script&lang=js&"
export * from "./MyLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports